import React from 'react';
import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import store from 'root/admin/store';
import { Form, Field, Loader, Row } from '@smartplatform/ui';
import { Editor } from '../../components';

const EditInformation = ({ match, rootPath, tabName }) => {
	const { id, iid } = match.params;
	const options = {};
	const record = useGetRecord({ model: 'AwardInformation', id: iid, options, tabName });

	const beforeSave = record => {
		record.awardId = id;
	};

	if (!record) {
		return <Loader />;
	}

	const onError = (e) => {
		if (e) {
			const error = e.details.messages.name || e.message;
			store.ui.setNotification({ message: error,error })
		};
	};

	return (
		<>
			<Title record={record} name="Информация о награде" />

			<Form record={record} onError={onError} rootPath={`${rootPath}/${id}`} beforeSave={beforeSave}>
				<Field property="name" label="Название" />
				<Field property="text" label="Текст информации">
					<Editor />
				</Field>
			</Form>
		</>
	);
};

// @withRouter
// @observer
// export default class EditInformation extends React.Component {
// 	@observable record;
// 	@observable id;

// 	async componentDidMount() {
// 		const { id, iid } = this.props.match.params;

// 		let record = await store.model.AwardInformation.findById(iid)

// 		this.id = id;
// 		this.record = record;
// 	}

// 	beforeSave = record => {
// 		record.awardId = this.id;
// 	};

// 	render() {
// 		const {
// 			id,
// 			props: { rootPath },
// 		} = this;

// 		return (
// 			<div>
// 				{this.record && this.record.id && (
// 					<>
// 						<Title record={this.record} name="Информация о награде" />

// 						<Form record={this.record} rootPath={`${rootPath}/${id}`} beforeSave={this.beforeSave}>
// 							<Field property="name" label="Имя" />
// 							<Row>
// 								<Field property="text" label="Текст информации">
// 									<SlateEditor noImages />
// 								</Field>
// 							</Row>
// 						</Form>
// 					</>
// 				)}
// 			</div>
// 		);
// 	}
// }

export default withRouter(EditInformation);
